<template>
    <div class="global-chat-avatar-bubble" v-bind:style="avatarStyle"  v-bind:class="{online: this.online, 'global-chat-avatar-bubble-status': showStatus, 'global-chat-admin': canModerate}">
      <span v-if="chatRoom" class="chat-bubble" aria-label="Chat Icon" role="img">
        <i class="fas fa-comments"></i>
      </span>
      <span v-else-if="!avatar" :aria-label="'User Initials: ' + formattedInitials" role="img">{{ formattedInitials }}</span>
      <span v-else :aria-label="formattedInitials" role="img"></span>
      <!-- <img v-else :src="avatar" style="width: 100%; height:100%; border-radius: 20px;" :alt="formattedInitials"/> -->
    </div>
</template>

<script>

export default {

  props: ['firstName', 'lastName', 'avatar', 'online', 'showStatus', 'canModerate', 'chatRoom'],

  computed: {
    avatarStyle: function () {
      if (this.avatar) {
        return {
          backgroundImage: 'url("' + this.avatar + '")',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center'
        }
      }
      return {}
    },

    formattedInitials: function() {
      var firstChar = this.firstName && this.firstName[0] && this.firstName[0].toUpperCase()
      var secondChar = this.lastName && this.lastName[0] && this.lastName[0].toUpperCase()
      if (firstChar && secondChar) {
        return `${firstChar} ${secondChar}`
      }
      if (firstChar) {
        return firstChar
      }
      return ''
    },
  },
};
</script>
